//React
import React, { useEffect, useState, useContext } from "react";

//Material
import {
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from "@material-ui/core";
import {
  EditOutlined,
  ExpandMore,
  PersonAddSharp,
  Search,
  Add,
} from "@material-ui/icons";
import TableDefault from "../../../../components/grid/TableDefault";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

//OurComponents
import Chip from "../../../../components/basics/Chip";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { findClienteColaborador } from "../../../../repositories/qerpapi/erp/prouser/v1/ClientesColaboradoresRepository";
import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Prescricao";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { ModalPrescricaoCadastro } from "./ModalPrescricaoCadastro";
import { PrescricaoContext } from "../contexts/PrescricaoContext";

//Controller (functions)
import usePrescricaoController from "../controllers/PrescricaoController";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import SearchSelect from "../../../../components/inputs/SearchSelect";

let temporizer = null;
const AccordionPrescricaoGerais = ({ ...props }) => {
  const {
    expanded,
    clienteFilter,
    setClienteFilter,
    colaboradorFilter,
    setcolaboradorFilter,
    addColabOpen,
    setAddColabOpen,
    colaboradorSelected,
    setColaboradorSelected,
    dataColabTable,
    setDataColabTable,
  } = useContext(PrescricaoContext);

  const { handleChangeOpenAcordion, HandleAddModalColaborador } =
    usePrescricaoController();
  const { queryParams } = useContext(QueryParamsContext);

  const [loadingTable, setLoadingTable] = useState(false);
  const [searchClientOpen, setSearchClientOpen] = useState(false);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlined />,
                name: "Editar",
                action: () => {
                  HandleAddModalColaborador(item);
                },
              },
            ]}
          />
        );
      },
    },
    {
      id: "nome",
      label: "Nome",
    },
    {
      id: "cpf",
      label: "CPF",
    },
  ];

  const columnsClient = [
    {
      label: "Razao",
      id: "razao",
    },
    {
      label: "CPF/CNPJ",
      id: "cpfcnpj",
    },
  ];

  useEffect(() => {
    if (!clienteFilter) return;
    (async () => {
      try {
        setLoadingTable(true);
        const resultClienteColaborador = await findClienteColaborador({
          where: { cliente_id: clienteFilter.id },
          empresa_cnpj: queryParams?.empresa_cnpj || "",
        });
        if (resultClienteColaborador.success) {
          setDataColabTable(resultClienteColaborador.data ?? []);
        }
      } catch (error) {
      } finally {
        setLoadingTable(false);
      }
    })();
    // eslint-disable-next-line
  }, [clienteFilter]);

  useEffect(() => {
    if (!colaboradorFilter) return;
    (async () => {
      clearTimeout(temporizer);
      temporizer = setTimeout(async () => {
        try {
          setLoadingTable(true);
          const resultColaborador = await findClienteColaborador({
            where: {
              cliente_id: clienteFilter.id,
            },
            orwhere: {
              nome: `${colaboradorFilter}`,
              cpf: `${colaboradorFilter}`,
            },
            empresa_cnpj: queryParams?.empresa_cnpj || "",
          });
          if (resultColaborador.success) {
            setDataColabTable(resultColaborador.data ?? []);
          }
        } catch (error) {
        } finally {
          setLoadingTable(false);
        }
      }, 1500);
    })();
  }, [
    colaboradorFilter,
    clienteFilter,
    setDataColabTable,
    queryParams.empresa_cnpj,
  ]);

  const handleSelectClient = (setSearchClientOpen, selectedClient) => {
    setSearchClientOpen(false);
    setClienteFilter(selectedClient[0] || null);
  };

  // View
  return (
    <>
      {searchClientOpen && (
        <SearchDialog
          open={searchClientOpen}
          setOpen={setSearchClientOpen}
          columns={columnsClient}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectClient}
          route="prouser/clientes/v1"
          title="CLIENTES"
        />
      )}
      {addColabOpen && <ModalPrescricaoCadastro />}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded?.gerais || false}
          onChange={() => handleChangeOpenAcordion("gerais")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    bgcolor="primary"
                    textcolor="white"
                    label="DADOS GERAIS"
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} justifyContent="space-between">
              <Chip
                bgcolor="secondary"
                textcolor="black"
                label="CLIENTE"
                title="CLIENTE"
                spacing="4"
              />
              <Grid item lg={10} md={10} sm={10} xs={10}>
                <SearchSelect
                  id="clienteRazao"
                  getOptionLabel={(option) =>
                    `${option.cpfcnpj} - ${option.razao}`
                  }
                  label="Razao"
                  setValue={setClienteFilter}
                  route="prouser/clientes/v1"
                  filter="razao"
                  value={clienteFilter ?? ""}
                />
              </Grid>
              <Grid item flex={1}>
                <Tooltip title="Pesquisa Cliente">
                  <IconButtonStyled>
                    <Search
                      onClick={() => {
                        setSearchClientOpen(true);
                      }}
                    />
                  </IconButtonStyled>
                </Tooltip>
              </Grid>
              <Grid item flex={1}>
                <Tooltip title="Adicionar Cliente">
                  <IconButtonStyled>
                    <PersonAddSharp
                      onClick={() =>
                        window.open(
                          `/prouser/cliente/cadastro?empresa_cnpj=${
                            queryParams?.empresa_cnpj || ""
                          }&empresa_id=${queryParams?.id || ""}`
                        )
                      }
                    />
                  </IconButtonStyled>
                </Tooltip>
              </Grid>
              <Chip
                bgcolor="secondary"
                textcolor="black"
                label="COLABORADOR"
                title="COLABORADOR"
                spacing="4"
              />
              <Grid item lg={11} md={11} sm={11} xs={11}>
                <TextFieldErp
                  value={colaboradorFilter}
                  setValue={setcolaboradorFilter}
                  label="Busque por Nome, CPF/CNPJ"
                  variant="filled"
                  disabled={loadingTable}
                />
              </Grid>
              <Grid item flex={1}>
                <Tooltip
                  title={
                    clienteFilter
                      ? "Adicionar um Colaborador"
                      : "Selecionar um CLiente antes de um Colaborador"
                  }
                >
                  <IconButtonStyled>
                    <Add
                      onClick={() => {
                        if (clienteFilter) setAddColabOpen(true);
                      }}
                    />
                  </IconButtonStyled>
                </Tooltip>
              </Grid>
              <Grid item xs={12}>
                <TableContent>
                  <Grid item xs={12}>
                    <TableDefault
                      loading={loadingTable}
                      columns={columns}
                      values={dataColabTable}
                      tableTitle=""
                      selectable={true}
                      selected={colaboradorSelected}
                      setSelected={setColaboradorSelected}
                      multiSelect={false}
                    />
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export { AccordionPrescricaoGerais };
